<div
  *ngIf="basket && basket.totalItems > 0"
  class="totals"
>
  <div class="totals__item">
    <p>{{ 'basket_modal_subtotal' | i18next }}</p>
    <p class="price">{{ subtotalBasketPrice | currency }}</p>
  </div>
  <div *ngIf="basket.discount" class="totals__item">
    <p>{{ basket.discount.voucherCode }}</p>
    <p class="discount">-{{ basket.discount.totalDiscountValue | currency }}</p>
  </div>
  <div class="line"></div>
  <div class="totals__item">
    <p class="total">{{ 'basket_modal_total' | i18next }}</p>
    <p class="total">{{ totalBasketPrice | currency }}</p>
  </div>
</div>
